import BreadCrumbComponent from "../components/Items/BreadCrumb/Index";
import VoucherSearchComponent from "../components/vouchers/VoucherSearchComponent";

const VoucherSearchPage = () => {
  return (
    <>
      <BreadCrumbComponent
        lastItem="Search Voucher"
        routes={[{ title: "Home", path: "/" }]}
      />
      <VoucherSearchComponent />
    </>
  );
};
export default VoucherSearchPage;
